/* eslint-disable perfectionist/sort-objects */
import { MolsonDxGrid } from '@components/reusable'
import { molsonStyled } from '@/theme/customMuiExports'

export const ColorizedHeaderDxGrid = molsonStyled(MolsonDxGrid)(
  ({ theme }) => ({
    '& .dx-datagrid-header-panel': {
      backgroundColor: theme.palette.secondary[100]
    }
  })
)

export const StyledDxGrid = molsonStyled(MolsonDxGrid)(
  ({ borderColor }: { borderColor?: string }) => {
    const borderSide = `1px solid ${borderColor}`

    return {
      '& .dx-datagrid': {
        backgroundColor: 'transparent !important'
      },
      '& .dx-datagrid-borders .dx-datagrid-rowsview, .dx-datagrid-headers+.dx-datagrid-rowsview, .dx-datagrid-rowsview.dx-datagrid-after-headers':
        {
          borderBottomWidth: borderSide ? 0.5 : 1,
          borderRadius: '0 0 8px 8px',
          borderBottom: borderSide,
          borderLeft: borderSide,
          borderRight: borderSide
        },
      '& .dx-datagrid-headers': {
        borderLeft: borderSide,
        borderRight: borderSide,
        borderTop: borderSide
      }
    }
  }
)

export const StyledWarrantiesGrid = molsonStyled(MolsonDxGrid)(({ theme }) => ({
  '& .dx-row:first-child': {
    borderBottom: `1px solid ${theme.palette.secondary[300]}`
  }
}))
